import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { PackagesContactInfo } from "./component";
import { IStoreState } from "../../../../reducers/types";
import {
  getFareTripDetailsById,
  getSelectedTrip,
} from "../../../flight-shop/reducer";

const mapStateToProps = (state: IStoreState) => {
  const selectedTrip = getSelectedTrip(state);
  return {
    tripDetails: selectedTrip?.tripId
      ? getFareTripDetailsById(state)[selectedTrip.tripId]
      : undefined,
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PackagesContactInfoConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedPackagesContactInfo = withRouter(
  connector(PackagesContactInfo)
);
